<template>
  <div class="pageDiv">
    <v-tabs v-if="$AuthSvc.isLogin() && !showList && (tournament!==null && tournament.formatType==='MATCH_PLAY')">
      <v-tab :class="{tabSelect:selectedMenu===1}" v-if="(hasTeamMatches || hasSingleMatches)" @click="selectMenu(1)">Match Play</v-tab>
      <v-tab :class="{tabSelect:selectedMenu===0}" @click="selectMenu(0)">Scores</v-tab>
    </v-tabs>

    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-text>
        <span class="label14 darkred">Login is required to view data</span>
      </v-card-text>
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && showList">
      <v-card-text>
        <v-card-text class="member-table-card" v-if="officialTournaments.length > 0">
          <v-card-title class="label18">
            OFFICIAL {{$AuthSvc.getYear()}} Tournaments
          </v-card-title>
          <hr class="listHr">
          <ul>
            <li v-for="tn in officialTournaments" :key="tn.tournamentId">
              <a class="tournament-btn" @click="selectTournament(tn)">
                <span class="schedDate">
                  {{printDateTime(tn.tournament.scheduleDate)}}
                </span>

                <span class="courseName">
                  {{tn.course.name}} {{tn.tournament.sponsorName === "" ? "" : " - " + tn.tournament.sponsorName}}
                </span>
                <span style="color:red;margin-left:12px" v-if="tn.tournament.status!=='OFFICIAL' && tn.tournament.status!=='CLOSE'">
                  <span class="unofficial">(UNOFFICIAL)</span></span>
              </a>
              <hr class="listHr">
            </li>
          </ul>
        </v-card-text>

        <v-card-text class="member-table-card" v-if="funTournaments.length > 0">
          <v-card-title style="margin-top:30px;">
            <span class="label18">
              FUN {{$AuthSvc.getYear()}} Tournaments
            </span>
          </v-card-title>
          <hr class="listHr">
          <ul>
            <li v-for="tn in funTournaments" :key="tn.tournamentId">
              <a @click="selectTournament(tn)">
                <span class="schedDate">
                  {{printDateTime(tn.tournament.scheduleDate)}}
                </span>
                <span v-if="tn.tournament.sponsorName !==null && tn.tournament.sponsorName !==''" class="courseName">
                  {{tn.tournament.sponsorName}} - &nbsp;
                </span>
                <span class="courseName">
                  {{tn.course.name}}
                </span>
                <span style="color:red;margin-left:12px" v-if="tn.tournament.status!=='OFFICIAL' && tn.tournament.status!=='CLOSE'"><b>(UNOFFICIAL)</b></span>
              </a>
              <hr class="listHr">
            </li>
          </ul>
        </v-card-text>

        <br><br>

        <v-card-text class="member-table-card" v-if="historyTournaments.length > 0">
          <br>
          <span class="label18">History</span>

          <hr style="margin: 5px 0">
          <span class="label16">Official Tournaments</span><br><br>
          <div v-for="hist in historyTournaments.slice().reverse()" :key="hist.year">
            <span class="label16">{{hist.year}}</span>
            <hr class="listHr">
            <ul>
              <li v-for="tn in hist.list.slice().reverse()" :key="tn.tournamentId" v-if="tn.tournament.formatType==='TOURNAMENT'">
                <a @click="selectTournament(tn)">
                <span style="display:inline-block;width:100px">
                  {{printDate(tn.tournament.scheduleDate)}}
                </span>

                <span style="courseName">
                  {{tn.course.name}} {{tn.tournament.sponsorName === "" ? "" : " - " + tn.tournament.sponsorName}}
                </span>
                </a>
                <hr class="listHr">
              </li>
            </ul>
            <br>
          </div>

          <br>
          <span class="label18">FUN Tournaments</span><br><br>
          <div v-for="hist in historyTournaments.slice().reverse()" :key="hist.year">
            <span class="label16">{{hist.year}}</span>
            <hr class="listHr">
            <ul>
              <li v-for="tn in hist.list.slice().reverse()" :key="tn.tournamentId" v-if="tn.tournament.formatType!=='TOURNAMENT'">
                <a @click="selectTournament(tn)">
                <span style="display:inline-block;width:100px">
                  {{printDate(tn.tournament.scheduleDate)}}
                </span>
                  <span style="display:inline-block;width:120px">
                  {{$AuthSvc.printFormat(tn.tournament.formatType)}}
                </span>
                  <span style="courseName">
                  {{tn.course.name}}
                </span>
                </a>
                <hr class="listHr">
              </li>
            </ul>
            <br>
          </div>

        </v-card-text>

      </v-card-text>
    </v-card>

    <v-card v-if="selectedMenu === 0 && !showList">

      <v-card-text class="member-table-card" >
        <div v-if="tournament !== null && course !== null">
          <v-card-title style="padding-bottom:0">
            <span style="color:red;margin-left:12px" v-if="tournament.status!=='OFFICIAL' && tournament.status!=='CLOSE'"><b>(UNOFFICIAL)</b></span>
          </v-card-title>
          <br>
          <span class="label16">{{course!==null?course.name:''}}
            ( {{$AuthSvc.printFormat(tournament.formatType)}} )
          </span>

          <br> <br>
          <div v-if="(tournament.status === 'OFFICIAL' || tournament.status === 'CLOSE') && tournament.winnerMessage !== ''">
            <span class="messageText" v-html="tournament.winnerMessage"></span>
            <br>
            <br>
          </div>
          <div v-if="tournament.status === 'REVIEW' && $AuthSvc.isAdmin()">
            <span class="messageText" v-html="tournament.winnerMessage"></span>
            <br>
            <br>
          </div>

          <a style="margin-left: 15px" :href="'/grouping?id='+tournament.tournamentId">
            <span class="label14"> Show Groupings</span>
          </a>
          <br><br>
          <div v-if="$AuthSvc.isLogin() && $AuthSvc.getUserid() === 'bvhoang'">
            <a style="margin-left: 15px" :href="'/grouping-pic?id='+tournament.tournamentId">
              <span class="label14"> My Groupings</span>
            </a>
            <br><br>
          </div>

          <span class="label14" style="display:inline-block;float-left;margin-left:5px">Participants ({{players.length}} players)</span>

          <div  v-if="!$AuthSvc.isMobile()" style="display:inline-block;margin-left:60px;">
            <br>
            <input type="checkbox" style="width:25px;height:25px;" v-model="selectPlyr">
            <span class="label14" style="margin-left: 8px; v-align: middle;">
              Select
            </span>
            <span style="display:inline-block;width:15px;"></span>
            <input type="checkbox" style="width:25px;height:25px;" v-model="showScores" @change="changeShowHole()">
            <span class="label14" style="margin:0 0 0 7px;">
              Hole By Hole
            </span>
          </div>
        </div>

        <v-simple-table class="simple-table">
          <tr>
            <th width="5px" v-if="!$AuthSvc.isMobile()"></th>
            <th width="5px">#</th>
            <th style="width:300px !important">Name</th>
            <th width="10px" v-if="!showScores">{{$AuthSvc.isMobile()?'Flt':'Flight'}}</th>
            <th width="10px">
              <a class="sortLink" @click="sort('score')">
                <span v-if="$AuthSvc.isMobile()">SCR</span>
                <span v-if="!$AuthSvc.isMobile()">Score</span>
              </a>
            </th>
            <th width="10px" v-if="!showScores && tournament !== null && tournament.status === 'ACTIVE'">Thru</th>
            <th width="10px" v-if="!showScores && tournament!==null">HCP</th>
            <th width="10px" v-if="!showScores && tournament!==null">
              <a class="sortLink" @click="sort('net')">Net</a>
            </th>
            <th width="10px" v-if="!showScores && isTournament(tournament)">
              <a class="sortLink" @click="sort('point')">PTS</a>
            </th>
            <th v-if="showScores">Hole</th>

            <th v-if="showScores" style="text-align:center;">
              <div style="display: flex;">
                <div class="scoreBox" v-for="(par, index) in pars" :key="par" width="10px">
                  <span>{{index+1}}</span>
                </div>
              </div>
            </th>
          </tr>
          <tr v-if="showScores">
            <th width="5px" v-if="!$AuthSvc.isMobile()"></th>
            <th width="5px"></th>
            <th style="width:300px !important"></th>
            <th width="10px" v-if="!$AuthSvc.isMobile() && !showScores"></th>
            <th width="10px"></th>
            <th>PAR</th>
            <th style="text-align:center;">
              <div style="display: flex;">
                <div class="scoreBox" v-for="(par, index) in pars" :key="par" width="10px">
                  <span>{{par}}</span>
                </div>
              </div>
            </th>
          </tr>
          <tr v-for="n in players" :key="n" v-if="!selectPlyr || (selectPlyr && n.selected)">
            <td v-if="!$AuthSvc.isMobile()">
              <input type="checkbox" style="width:18px;height:18px;" v-model="n.selected">
            </td>
            <td width="10px" :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}">
              <div v-if="n.thruHoles===18 && n.playTeebox!==null" class="teebox" :class="{whiteTee: n.playTeebox==='White', redTee: n.playTeebox==='Red'}"></div>
              {{(showMatches(n))?n.team+'_'+n.ateam:n.rank}}
            </td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}">
              <span>{{getName(n)}}</span>
              <v-img class="member-logo" v-if="n.memberId > 0" src="../../assets/img/dfwvga-logo-mini.png">
              </v-img>
            </td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="!showScores">
              {{$AuthSvc.isMobile()?n.flight.charAt(0):n.flight}}
            </td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}">{{score(n)}}</td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" width="10px" v-if="!showScores && tournament !== null && tournament.status === 'ACTIVE'">{{thruHoles(n)}}</td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="!showScores && tournament!==null">{{$AuthSvc.getHcp(n.handicap)}}</td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="!showScores && tournament!==null">
              {{(n.net === null || n.net > 150)?'N/A':Number(n.net).toFixed(1)}}
            </td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="!showScores && isTournament(tournament)">
              {{Number(n.txPoint===null?'':n.txPoint).toFixed(1)}}
            </td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="showScores"></td>
            <td :class="{oddTeam: isOddMatch(n), evenTeam: isEvenMatch(n)}" v-if="showScores">
              <div style="display: flex;">
                <div class="score scoreBox" v-for="(sc, index) in n.scores" :key="sc">
                 <span :class="{scoreBirdie: isBirdie(sc, pars[index]), scoreBogey: isBogey(sc, pars[index])}">
                    <span :class="{scoreEagle: isEagle(sc, pars[index]), scoreDbogey: isDbogey(sc, pars[index])}">
                      <span :class="{scoreFont: sc < 10, scoreFont10: sc > 9}">{{sc > 0 ? sc : ''}}</span>
                    </span>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </v-simple-table>
      </v-card-text>

      <v-card-text style="margin-top: 20px;" v-if="tournament.formatType !== 'FUN'">
        <v-btn v-if="this.$AuthSvc.isAdmin() && tournament.status==='REVIEW'"
               class="primary-btn calculate-btn"
               @click="calculateTournament()">
          Calculate
        </v-btn>
      </v-card-text>
    </v-card>

    <v-card class="main-card" v-if="hasTeamMatches || hasSingleMatches">
      <span class="label24 cupLabel">Match Play Results</span>
      <div style="width:100%;height:40px;padding:0 10px">
        <div class="homeDiv">
          <span class="label18">{{tournament.homeTeam}}: </span>
          <span class="label20">{{homePointsFinal}}</span>
        </div>
        <div class="awayDiv">
          <span class="label18">{{tournament.awayTeam}} : </span>
          <span class="label20">{{awayPointsFinal}}</span>
        </div>
      </div>

      <div class="group-card" >
        <v-simple-table class="simple-table" v-if="hasTeamMatches">
          <tr>
            <th>{{tournament.homeTeam}} Team</th>
            <th>VS</th>
            <th>{{tournament.awayTeam}} Team</th>
            <th width="10px">Thru</th>
          </tr>
          <tr style="margin-bottom: 3px;" v-for="group in groups" :key="group">
            <td :class="{winnerDiv: group.score != null && group.score.includes('UP')}">{{group.aTeam[0]}} <br> {{group.aTeam[1]}}</td>
            <td>
              <span class="label14">
                {{group.score === null || group.score === 0 ? "A/S" : group.score}}
              </span>
            </td>
            <td :class="{winnerDiv: group.score != null && group.score.includes('DN')}">{{group.bTeam[0]}} <br> {{group.bTeam[1]}}</td>
            <td>
              <span class="label20">
                {{group.thruHoles === 18 || (group.score !== null && group.score.includes('&')) ? "F" : group.thruHoles}}
              </span>
            </td>
          </tr>
        </v-simple-table>

        <v-simple-table class="simple-table" v-if="hasSingleMatches">
          <tr>
            <th>{{tournament.homeTeam}} Player</th>
            <th>VS</th>
            <th>{{tournament.awayTeam}} Player</th>
            <th width="10px">Thru</th>
          </tr>
          <tr style="margin-bottom: 3px;" v-for="mt in singleMatches" :key="mt">
            <td :class="{winnerDiv: mt[0].amatchScore != null && mt[0].amatchScore.includes('UP')}">{{getName(mt[0])}}</td>
            <td>
              <span class="label14">
                {{mt[0].amatchScore===null?'A/S' : mt[0].amatchScore}}
              </span>
            </td>
            <td :class="{winnerDiv: mt[0].amatchScore != null && mt[0].amatchScore.includes('DN')}">{{getName(mt[1])}}</td>
            <td>
              <span class="label20">
                {{mt[0].thruHoles === 18 || (mt[0].amatchScore !== null && mt[0].amatchScore.includes('&')) ? "F" : mt[0].thruHoles}}
              </span>
            </td>
          </tr>
        </v-simple-table>
      </div>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import swal from 'sweetalert';

    export default {
      name: "login",
      data: () => ({
        selectCourse: null,
        tournament: null,
        course: null,
        historyTournaments: [],
        officialTournaments: [],
        funTournaments: [],
        players: [],
        nicklaus: [],
        palmer: [],
        hogan: [],
        women: [],
        nonMember: [],
        showList: true,
        pars: [],
        selectPlyr: false,
        showScores: false,
        hasMatches: false,
        hasTeamMatches: false,
        hasSingleMatches: false,
        hasScoreView: false,
        groups: [],
        singleMatches: [],
        homePointsFinal: 0,
        awayPointsFinal: 0,
        selectedMenu: 0
      }),
      mounted: function() {
        var _this = this;

        _this.showScores = _this.$AuthSvc.showHole();

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id')
        if (id !== null && id !== '') {
          _this.$CommandSvc.get(_this, '/public/tournaments/' + id, function(data) {
            _this.tournament = data;
            _this.loadPlayerList(_this.tournament);
            _this.loadGroups();
            _this.hasTeamMatches = _this.tournament.teamMatch === 'Y';
            _this.hasSingleMatches = _this.tournament.singleMatch === 'Y';
            _this.showList = false;

            if (_this.tournament.formatType === 'MATCH_PLAY') {
              _this.selectMenu(1);
            }
            else {
              _this.selectMenu(0);
            }
          });
        } else {
          _this.$CommandSvc.get(_this, '/public/tournaments/status/RESULTS', function(data) {
            _this.tournament = null;
            _this.course = null;

            _this.historyTournaments = new Array();
            _this.officialTournaments = new Array();
            _this.funTournaments = new Array();

            for(var i=0; i < data.length; i++) {
              if (['2-SCRAMBLE', 'BANQUET', 'CUP'].includes(data[i].tournament.formatType)) {
                continue;
              }

              _this.course = data[i].course;
              var tournament = data[i].tournament;
              var year = moment(tournament.scheduleDate).format('YYYY');
              console.log("YEAR" + year);

              if (data[i].tournament.status === 'CLOSE') {
                var found_k = -1;
                for(var k=0; k < _this.historyTournaments.length; k++) {
                  if (_this.historyTournaments[k].year === year) {
                    found_k = k;
                    break;
                  }
                }


                if (found_k === -1) {
                  var histVar = {
                    year: year,
                    list: new Array()
                  };
                  _this.historyTournaments.push(histVar);
                  found_k = _this.historyTournaments.length-1;
                }

                _this.historyTournaments[found_k].list.push(data[i]);
              }
              else if (_this.isTournament(data[i].tournament)) {
                _this.officialTournaments.push(data[i]);
              }
              else if (['FUN', 'FUN_FW', 'FUN_FW_TEAM'].includes(data[i].tournament.formatType)) {
                _this.funTournaments.push(data[i]);
              }
            }

            if (_this.course !== null) {
              var pars = JSON.parse(_this.course.par);
              pars.splice(9,1);
              pars.splice(18,1);
              pars.splice(18,1);
              _this.pars = pars;
            }
          });
        }
      },
      methods: {
        selectMenu: function(menu) {
          this.selectedMenu = menu;
        },
        sort(field) {
          if (field === 'score') {
              this.players.sort((a, b) => ( a.score > b.score ) ? 1 : -1);
              this.pushDNPBottom();
          }
          else if (field === 'net') {
              this.players.sort((a, b) => ( a.net > b.net ) ? 1 : -1);
              this.pushDNPBottom();
          }
          else if (field === 'point') {
              this.players.sort((a, b) => ( a.txPoint < b.txPoint ) ? 1 : -1);
          }
        },
        isTournament(tournament) {
          if (tournament !== null) {
            return ['TOURNAMENT'].includes(tournament.formatType);
          }
          return null;
        },
        pushDNPBottom() {
          var found = false;
          for(var i=0; i < this.players.length; i++) {
            if (this.players[i].thruHoles === 18) {
              found = true;
              break;
            }
          }

          if (found) {
            while(this.players[0].thruHoles < 18) {
              if (this.players[0].thruHoles < 18) {
                this.players.push(this.players.splice(0, 1)[0]);
              }
            }
          }
        },
        getName(player) {
          if (player !==  null && player.firstName !== undefined) {
            if (player.firstName === 'Guest') {
              return player.nickName;
            }
            else {
              return player.firstName + " " +
                  (player.middleName!==null && player.middleName!==''?player.middleName.charAt(0):'')
                  + " " + player.lastName;
            }
          }
          return "";
        },
        getNameMatch(player) {
          if (player !==  null && player.firstName !== undefined) {
            if (player.thruHoles === 18) {
              return this.getName(player) + ' (' + player.score + ')';
            } else {
              return this.getName(player) + ' (' + player.to_par + ')';
            }
          }
          return "";
        },
        getTeebox(teebox) {
          if (teebox === 'Blue') {
             return "Blue";
          } else if (teebox === 'White') {
             return "White";
          } else {
             return teebox;
          }
        },
        score(n) {
          if (this.tournament.status === 'ACTIVE') {
            if (n.thruHoles === 18) {
              return n.score;
            } else {
              if (n.toPar === 0) {
                return "E";
              }
              else if (n.toPar > 0) {
                return "+" +  n.toPar;
              }
              else {
                return n.toPar;
              }
            }
          }
          else {
            if (n.thruHoles === 0) {
              return "DNP";
            }
            else if (n.thruHoles < 18) {
              return 'DNF';
            }
            else if (n.thruHoles === 18) {
              return n.score;
            }
          }
        },
        thruHoles(n) {
          if (this.tournament.status === 'ACTIVE') {
            if (n.thruHoles < 18) {
              return n.thruHoles;
            } else {
              return 'F'
            }
          }
          else {
            if (n.thruHoles === 0) {
              return "DNP";
            }
            else if (n.thruHoles < 18) {
              return 'DNF';
            }
            else {
              return 'F'
            }
          }
        },
        printDate(date) {
          return moment(date).format('MMMM DD');
        },
        printDateTime(date) {
          return moment(date).format('MMM DD hh:mm A');
        },
        changeShowHole() {
          console.log('CHANGE: ' + this.showScores);
          //this.$AuthSvc.setShowHole(this.showScores);
        },
        selectTournament(tn) {
          this.course=tn.course;
          if (this.course !== null) {
            var pars = JSON.parse(this.course.par);
            pars.splice(9,1);
            pars.splice(18,1);
            pars.splice(18,1);
            this.pars = pars;
          }
          this.tournament = tn.tournament;
          window.location.href = "/results?id=" + tn.tournament.tournamentId;
        },
        calculateTournament() {
          var _this = this;
          console.log('CALCULATE /admin/calculate-tourament');
          this.$CommandSvc.get(this, '/admin/calculate-tournament/' + _this.tournament.tournamentId, function(data) {
            console.log('CALCULATE Success: ' + data);
             swal({
                title: "Success!",
                text: "Texas Cup points calculated.",
                type: "info"
            }).then(function() {
                window.location.reload();
            });
          });
        },
        loadPlayerList(tournament) {
          var _this = this;

          _this.$CommandSvc.get(_this, '/public/courses/' + tournament.courseId, function(data) {
            _this.course = data;
            if (_this.course !== null) {
              var pars = JSON.parse(_this.course.par);
              pars.splice(9,1);
              pars.splice(18,1);
              pars.splice(18,1);
              _this.pars = pars;
            }
          });

          _this.$CommandSvc.get(_this, '/public/tournaments/' + tournament.tournamentId + '/results', function(data) {
            _this.players = new Array();
            var actualList = new Array();
            var dnfList = new Array();

            var i;
            for(i=0; i < data.length; i++) {
              var scoreCard = data[i];

              scoreCard.scores = new Array();
              scoreCard.scores.push(data[i].hole_1);
              scoreCard.scores.push(data[i].hole_2);
              scoreCard.scores.push(data[i].hole_3);
              scoreCard.scores.push(data[i].hole_4);
              scoreCard.scores.push(data[i].hole_5);
              scoreCard.scores.push(data[i].hole_6);
              scoreCard.scores.push(data[i].hole_7);
              scoreCard.scores.push(data[i].hole_8);
              scoreCard.scores.push(data[i].hole_9);
              scoreCard.scores.push(data[i].hole_10);
              scoreCard.scores.push(data[i].hole_11);
              scoreCard.scores.push(data[i].hole_12);
              scoreCard.scores.push(data[i].hole_13);
              scoreCard.scores.push(data[i].hole_14);
              scoreCard.scores.push(data[i].hole_15);
              scoreCard.scores.push(data[i].hole_16);
              scoreCard.scores.push(data[i].hole_17);
              scoreCard.scores.push(data[i].hole_18);

              if (_this.showMatches(scoreCard)) {
                _this.players.push(scoreCard);
                continue;
              }

              if (scoreCard.thruHoles === 18) {
                actualList.push(scoreCard);
              }

              if (scoreCard.thruHoles < 18) {
                dnfList.push(scoreCard);
              }
            }

            var rank = 0;
            for (i=0; i < actualList.length; i++)
            {
              rank++;
              actualList[i].rank = '' + rank;

              if (i > 0) {
                if (actualList[i].score === actualList[i-1].score) {
                  if (actualList[i-1].rank.charAt(0) === 'T') {
                    actualList[i].rank = actualList[i-1].rank;
                  }
                  else {
                    actualList[i].rank = 'T' + actualList[i-1].rank;
                    actualList[i-1].rank = actualList[i].rank;
                  }
                }
              }

              _this.players.push(actualList[i]);
            }

            for (i=0; i < dnfList.length; i++)
            {
              _this.players.push(dnfList[i]);
            }

            _this.sort('score');
          });
        },
        loadGroups: function() {
          var _this = this;
          this.axios.get('/public/scores/score-card/group/' + this.tournament.tournamentId)
          .then(function (response) {
            _this.groups = new Array();
            _this.singleMatches = new Array();

            var p, g;
            var players = response.data;

            for(p=0; p < players.length; p++) {

              if (players[p].matchPlay === 'Y') {
                _this.hasMatches = true;
              }
              else {
                continue;
              }

              var foundGroup = -1;
              for(g=0; g < _this.groups.length; g++) {
                  if (_this.groups[g].groupId === players[p].groupId) {
                    foundGroup = g;
                    break;
                  }
              }

              var grp = null;

              if (foundGroup === -1 ) {
                grp = {
                  groupId: players[p].groupId,
                  aTeam: new Array(),
                  bTeam: new Array(),
                  aPlayers: new Array(),
                  bPlayers: new Array(),
                  score: '',
                  thruHoles: 0
                };

                if (players[p].team === 'A') {
                  grp.aTeam.push(_this.getNameMatch(players[p]));
                  grp.score = players[p].matchScore;
                  grp.thruHoles = players[p].thruHoles;
                }
                else {
                  grp.bTeam.push(_this.getNameMatch(players[p]));
                }

                if (players[p].ateam === "1") {
                  grp.aPlayers.push(players[p]);
                } else {
                  grp.bPlayers.push(players[p]);
                }
                _this.groups.push(grp);
              }
              else {
                grp = _this.groups[foundGroup];
                if (players[p].team === 'A') {
                  grp.aTeam.push(_this.getNameMatch(players[p]));
                  grp.score = players[p].matchScore;
                }
                else {
                  grp.bTeam.push(_this.getNameMatch(players[p]));
                }

                if (players[p].ateam === "1") {
                  grp.aPlayers.push(players[p]);
                } else {
                  grp.bPlayers.push(players[p]);
                }
              }
            }

            _this.singleMatches = new Array();
            for(var k=0; k < _this.groups.length; k++) {
              _this.singleMatches.push(_this.groups[k].aPlayers);
              _this.singleMatches.push(_this.groups[k].bPlayers);
            }

            _this.homePointsFinal = 0.0;
            _this.awayPointsFinal = 0.0;

            var i;
            if (_this.hasTeamMatches) {
              for (i=0; i < _this.groups.length; i++) {
                if (_this.groups[i].aPlayers.length > 0) {
                  var grpScore = _this.groups[i].score;
                  if (_this.groups[i].aPlayers[0].thruHoles > 0 && _this.groups[i].score === 'A/S') {
                    if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                      _this.homePointsFinal += 0.5;
                      _this.awayPointsFinal += 0.5;
                    }
                  }
                  else if (_this.groups[i].aPlayers[0].thruHoles > 0 && (grpScore !== null && grpScore.includes('UP'))) {
                    if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                      _this.homePointsFinal += 1;
                    }
                  }
                  else if (_this.groups[i].aPlayers[0].thruHoles > 0 && (grpScore !== null && grpScore.includes('DN'))) {
                    if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                      _this.awayPointsFinal += 1;
                    }
                  }
                }
              }
            }

            if (_this.hasSingleMatches) {
              for(i=0; i < _this.singleMatches.length; i++) {
                if (_this.singleMatches.length > 0 && _this.singleMatches[i].length > 0) {
                  var score = _this.singleMatches[i][0].amatchScore;
                  if (_this.singleMatches[i][0].thruHoles > 0 && score === 'A/S') {
                    if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                      _this.homePointsFinal += 0.5;
                      _this.awayPointsFinal += 0.5;
                    }
                  }
                  else if (_this.singleMatches[i][0].thruHoles > 0 && (score !== null && score.includes('UP'))) {
                    if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                    _this.homePointsFinal += 1;
                    }
                  }
                  else if (_this.singleMatches[i][0].thruHoles > 0 && (score !== null && score.includes('DN'))) {
                    if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                    _this.awayPointsFinal += 1;
                    }
                  }
                }
              }
            }
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
        },
        isOddMatch(n) {
          return (this.tournament.formatType === 'MATCH_PLAY' && n.groupId%2 === 0);
        },
        isEvenMatch(n) {
          return (this.tournament.formatType === 'MATCH_PLAY' && n.groupId%2 !== 0);
        },
        showMatches(n) {
          return (this.tournament.formatType === 'MATCH_PLAY' && n.matchPlay==='Y');
        },
        isEagle: function(score, par) {
          if (score > 0) {
            return (Number(score) < Number(par)-1);
          }
          return false;
        },
        isBirdie: function(score, par) {
          if (score > 0 ) {
            return (Number(score) < Number(par));
          }
          return false;
        },
        isBogey: function(score, par) {
          if (score > 0) {
            return (Number(score) > Number(par));
          }
          return false;
        },
        isDbogey: function(score, par) {
          if (score > 0) {
            return (Number(score) > Number(par+1));
          }
          return false;
        },
      }
    }

</script>

<style scoped>

  .sortLink {
    color: yellow;
  }

  ul {
    margin-left: 0px;
    margin-top: 3px;
  }

  li {
    margin-left: 0;
    padding: 5px 0px !important;
  }

  .v-tabs {
    display: inline-block;
    width: 100%;
  }

  .v-tab {
    border-left: 1px solid black;
    border-right: 1px solid black;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
  }

  .tabSelect {
    font-weight: bold;
    color: darkblue;
    background: #e6f2ea;
  }

  .table.b-table>thead>tr>th {
    background-color: white;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 2;
  }

  .dollar {
    font-family: Copperplate !important;
  }

  .scoreBox {
    height: 30px;
    width: 50px;
    margin-right: 7px;
    border-right: 1px solid;
  }

  .homeDiv, awayDiv {
    display: inline-block;
    width: 200px
  }

  .homeDiv {
    float: left;
  }

  .awayDiv {
    float: right;
  }

  .tournament-btn {
    display: inline-block;
    width: 100%;
    padding: 2px 0px;
    font-size: 16px;
    font-weight: bold;
  }

  .unofficial {
    color: red;
    font-weight: bold;
  }

  .listHr {
    width: 100%;
  }

  @media (min-width: 768px) {
      body {
        min-width: 1280px;
      }

      ul {
        margin-left: 10px;
      }

      li {
        margin-left: 12px;
      }

      .tournament-btn {
        width: 700px;
      }

      .listHr {
        width: 100%;
      }
  }

  .member-table-card {
      overflow-y: scroll;
  }

  .course-name {
    display: inline-block;
    width: 100%s;
    margin-top: 20px;
  }

  .select-btn {
    margin-right: 20px;
    text-align: left;
    background-color: #1867c0;
    width:100%;
    border-radius: 7px;
    padding: 10px;
    color: white;
  }

  .select-btn:hover {
    cursor: pointer;
  }

  .member-logo {
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 45px;
    margin-left: 15px;
  }

  .calculate-btn {
    margin: 15px 0;
  }

  .scoreBirdie {
    border: 2px solid;
    border-radius: 25px;
    width: 33px;
    height: 32px;
    padding: 2px 0 0px 7px;
  }

  .scoreEagle {
    position: relative;
    border: 2px solid;
    width: 25px;
    height: 25px;
    border-radius: 25px;
    margin: 0 -5px;
  }

  .scoreBogey {
    border: 2px solid;
    width: 34px;
    height: 28px;
    padding: 0 0 0 3px !important;
  }

  .scoreBogey > span {

  }

  .scoreDbogey {
    position: relative;
    border: 2px solid;
    margin: 1px -1px;
    width: 26px;
    height: 22px;
    padding: 0 0 0 4px !important;
  }

  .scoreFont {
    font-size: 12px;
    margin-left: 5px
  }

  .scoreFont10 {
    font-size: 12px;
  }

  .score {
    text-align: middle;
  }

  .score span {
    display: inline-block;
  }

  .displayNone {
    display: none;
  }

  .schedDate {
    display: inline-block;
    padding-top: 2px;
    text-align: left;
    margin-right: 20px;
    font-size: 14px;
    font-weight: bold;
  }

  .courseName {
    display: inline-block;
    padding-top: 2px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
  }

  .cupLabel {
    display: inline-block;
    margin: 20px 10px;
    font-size: 24px;
    font-weight: bold;
  }

  .winnerDiv {
    background-color: lightgreen;
    font-weight: bold;
    font-size: 12px;
  }

  .oddTeam {
    background-color: lightgreen;
  }

  .evenTeam {
    background-color: lightgreen;
  }

</style>